// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrophyFilledSvg from "@ant-design/icons-svg/es/asn/TrophyFilled";
import AntdIcon from '../components/AntdIcon';

var TrophyFilled = function TrophyFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrophyFilledSvg
  }));
};

TrophyFilled.displayName = 'TrophyFilled';
export default React.forwardRef(TrophyFilled);